import { Button as AntdButton } from 'antd';
import React from 'react';

function buttonWhitColor(WrappedButton) {
  return function WrappedButtonWhitColor(props) {
    const { color = 'none', children, ...otherProps } = props;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (
      <WrappedButton
        {...otherProps}
        className={color ? `button-${color}` : null}
      >
        {children}
      </WrappedButton>
    );
  };
}

const Button = buttonWhitColor(AntdButton);

export default Button;
